/* eslint-disable complexity */

const Polyglot = require('node-polyglot');

export const polyglot = new Polyglot({locale: 'en'});

const getMessages = (language) => {
  switch (language) {
    case 'en':
      return require('../../resources/locales/en.json');

    case 'es':
      return require('../../resources/locales/es.json');

    case 'bg':
      return require('../../resources/locales/bg.json');

    case 'zh-cn':
      return require('../../resources/locales/zh-cn.json');

    case 'zh-tw':
      return require('../../resources/locales/zh-tw.json');

    case 'zh-hk':
      return require('../../resources/locales/zh-tw.json');

    case 'cs':
      return require('../../resources/locales/cs.json');

    case 'nl':
      return require('../../resources/locales/nl.json');

    case 'fi':
      return require('../../resources/locales/fi.json');

    case 'fr':
      return require('../../resources/locales/fr.json');

    case 'de':
      return require('../../resources/locales/de.json');

    case 'hu':
      return require('../../resources/locales/hu.json');

    case 'it':
      return require('../../resources/locales/it.json');

    case 'ja':
      return require('../../resources/locales/ja.json');

    case 'ko-kr':
      return require('../../resources/locales/ko-kr.json');

    case 'pl':
      return require('../../resources/locales/pl.json');

    case 'pt':
      return require('../../resources/locales/pt.json');

    case 'pt-br':
      return require('../../resources/locales/pt-br.json');

    case 'ro':
      return require('../../resources/locales/ro.json');

    case 'ru':
      return require('../../resources/locales/ru.json');

    case 'sv':
      return require('../../resources/locales/sv.json');

    case 'uk':
      return require('../../resources/locales/uk.json');

    case 'vi':
      return require('../../resources/locales/vi.json');

    default:
      return require('../../resources/locales/en.json');
  }
};

const supportedLanguages = [
  'en',
  'bg',
  'zh-cn',
  'zh-tw',
  'zh-hk',
  'cs',
  'nl',
  'fi',
  'fr',
  'de',
  'hu',
  'it',
  'ja',
  'ko-kr',
  'pl',
  'pt',
  'pt-br',
  'ro',
  'ru',
  'es',
  'sv',
  'uk',
  'vi',
];

export const setPreferredLanguage = (accountLanguage) => {
  let selectedLanguage = selectUserLanguage(accountLanguage);
  polyglot.locale(selectedLanguage);
  polyglot.extend(getMessages(selectedLanguage));
};

const selectUserLanguage = (accountLanguage) => {
  let selectedLanguage = navigator.language.toLowerCase();
  if (supportedLanguages.includes(selectedLanguage)) {
    return selectedLanguage;
  } else {
    const twoCharacterCode = selectedLanguage.split('-')[0];
    selectedLanguage = supportedLanguages.includes(twoCharacterCode)
      ? twoCharacterCode
      : accountLanguage;
    return selectedLanguage;
  }
};
